<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <wapi-panel :title="'Территория'" :spacing="false">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Карта</v-tab>
              <v-tab>Точки</v-tab>
              <v-tab-item>
                <wapi-geo-json-map v-model="geoJson"></wapi-geo-json-map>
              </v-tab-item>
              <v-tab-item>
                <div class="mx-2">
                  <v-switch dense v-model="pointsGeoJson" :label="switchLabel" outlined></v-switch>
                </div>
                <v-card flat>
                  <v-textarea
                    solo
                    name="input-7-4"
                    label
                    v-model="area"
                    auto-grow
                    :height="'415px;'"
                    dense
                    outlined
                  ></v-textarea>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-container fluid>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="preset.name"
                  label="Название территории"
                  :rules="[rules.required]"
                  outlined
                  dense
                ></v-text-field>
                <v-btn v-on:click="createPreset" color="primary">Сохранить</v-btn>
              </v-form>
            </v-container>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from "../models/helpers/rules";
import CreateOrderPreset from "../models/CreateOrderPreset.js";
import WapiPanel from "../components/WapiPanel";
import WapiGeoJsonMap from "../components/WapiGeoJsonMap.vue";
import { geoJsonToWapiPolygon } from "../helpers/wapihelpers.js";

export default {
  components: {
    WapiPanel,
    WapiGeoJsonMap
  },
  name: "AddPresets",
  title: "Добавление территории",
  data: function() {
    return {
      drawnItems: null,
      map: null,
      areaJson: "",
      preset: new CreateOrderPreset(),
      geoJson: null,
      dvariants: [],
      predicts: [],
      userId: "",
      presetId: "",
      result: [],
      rules: rules,
      valid: true,
      pointsGeoJson: false,
      coordinateOrder: []
    };
  },
  async created() {
    const contract = await this.$store.dispatch("FETCH_CONTRACT_INFO");
    this.coordinateOrder = contract.preset_settings.coordinate_order;
  },
  computed: {
    switchLabel() {
      return this.pointsGeoJson ? "GeoJson" : "";
    },
    area: {
      get: function() {
        if (!this.geoJson) {
          return null;
        }
        if (this.pointsGeoJson) {
          return JSON.stringify(this.geoJson);
        }
        return JSON.stringify(
          geoJsonToWapiPolygon(this.geoJson, this.coordinateOrder)
        );
      },
      set: async function(newValue) {
        if (newValue.length > 0) {
          try {
            this.areaJson = newValue;
            const parsed = JSON.parse(newValue);
            this.geoJson = parsed;
          } catch (err) {
            this.geoJson = null;
          }
        } else {
          this.geoJson = null;
        }
      }
    }
  },
  methods: {
    async createPreset() {
      let area = this.area;
      if (!area?.length) {
        await this.$store.dispatch("PUSH_ERROR_MESSAGE", "Укажите территорию!");
        return;
      }

      if (!this.preset.name) {
        await this.$store.dispatch("PUSH_ERROR_MESSAGE", "Укажите название!");
        return;
      }

      try {
        if (!this.pointsGeoJson) {
          area = JSON.stringify(this.geoJson);
        }

        window.L.geoJSON(JSON.parse(area));
      } catch (e) {
        await this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "GeoJSON не валидный!"
        );
        return;
      }

      const wapiPolygon2D = geoJsonToWapiPolygon(
        JSON.parse(area),
        this.coordinateOrder
      );

      await this.$store.dispatch("SET_LOADING", true);
      const newPreset = {
        name: this.preset.name,
        area: wapiPolygon2D
      };
      await this.$store.dispatch("CREATE_PRESET", [newPreset]);
      await this.$store.dispatch("SET_LOADING", false);
      this.preset = new CreateOrderPreset();
      this.geoJson = null;
      this.$router.push({ name: "USER_PRESETS" });
    }
  }
};
</script>